import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FormGroup, FormControl, FormLabel } from '@material-ui/core';
import CustomCheckbox from './CustomCheckbox';

const styles = (theme) => ({
  radioGroupLabel: {
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    color: theme.popupLeftColColor,
  },
  rowContainer: {
    gap: '8px',
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: theme.textFontSize,
    marginTop: 4,
  }
});

/* TODO: Make it more generic to: use some type of composition to render one/group of children */
const CheckboxGroup = ({ classes, headerLabel, options, onChange, isRadioType = false, errorMessage = null }) => {
  const handleChange = (event) => {
    const updatedSelections = options.map((item) => {
      if (item.name === event.target.name) {
        return { ...item, isChecked: event.target.checked };
      } else {
        if (isRadioType) {
          return { ...item, isChecked: false };
        }
        return { ...item };
      }
    });
    onChange?.(updatedSelections);
  };

  return (
    <FormControl component="fieldset">
      {headerLabel && (
        <FormLabel
          component="legend"
          classes={{
            root: classes.radioGroupLabel
          }}
          focused={false}>
          {headerLabel}
        </FormLabel>
      )}
      <FormGroup row classes={{ root: classes.rowContainer }}>
        {options.map((option) => {
          return (
            <CustomCheckbox
              name={option.name}
              labelText={option.labelText}
              isChecked={option.isChecked}
              handleChange={handleChange}
              tooltip={option.tooltip}
            />
          );
        })}
      </FormGroup>
      {errorMessage && (
        <span className={classes.errorText}>
          {errorMessage}
        </span>
      )}
    </FormControl>
  );
};

export default withStyles(styles)(CheckboxGroup);
